<div class="h-screen flex flex-column bg-cover" >
    <div class="shadow-3 z-3 bg-primary p-1 flex justify-content-between flex-row align-items-center">
        <div class="ml-3 flex cursor-pointer" [routerLink]="['/manage-portals']">
            <div>
              <img loading="lazy" [src]="'assets/layout/images/logos/clearbasin_horizontal_2-color_01.png'" alt="clearbasin_horizontal_1" class="h-3rem">
            </div>
        </div>
        <div class="mr-3 flex">
            <button pButton pRipple type="button" label="DASHBOARD" [routerLink]="['/manage-portals']"
                class="p-button-text text-white"></button>
        </div>
    </div>

    <div class="align-self-center mt-auto mb-auto">
      <div class="flex justify-content-center mb-4">
        <img src="assets/layout/images/pages/404.png" alt="" />
      </div>
      <div class="flex flex-column gap-2 align-items-center">
        <h1 class="m-0 text-bluegray-700 font-semibold">NOT FOUND!</h1>
        <span class="text-700">Requested resource is not available.</span>
      </div>
      <div class="flex justify-content-center mt-6">
        <button pButton pRipple type="button" label="BACK TO HOME" [routerLink]="['/manage-portals']"
                class="p-button-text bg-primary text-white"></button>
      </div>
    </div>
</div>
